import BreadCrumbComp from "../../components/breadCrumb";
import InterestedPartiesProcessTab from "./interestedPartiesProcessTab";
import HeaderBanner from "../../components/headerBanner";
import { headerBannerType } from "../../constants/enums";

const InterestedParties = () => {
  return (
    <div className="App">
      <BreadCrumbComp />
       <HeaderBanner type={headerBannerType.riskAndOportunity} />
      <div className="searchTitle">
        <h1>DASHBOARD PARTES INTERESADAS</h1>
      </div>
      <InterestedPartiesProcessTab />
    </div>
  );
};
export default InterestedParties;
